'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const TimeSeries=require('../../../../dist-es6/client/utilities/timeSeries');let

FatigueAlertPlotterDirective=function(_BaseControllerBacked){_inherits(FatigueAlertPlotterDirective,_BaseControllerBacked);function FatigueAlertPlotterDirective(){_classCallCheck(this,FatigueAlertPlotterDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(FatigueAlertPlotterDirective,[{key:'objectBindings',get:function()
{
return['points','threshold','ceiling','plotArea','verticalAxis','horizontalAxis','strokeWidth','offsetTop'];
}},{key:'textBindings',get:function()
{
return['class','mask'];
}},{key:'controller',get:function()

{
return FatigueAlertPlotterController;
}}]);return FatigueAlertPlotterDirective}(BaseControllerBackedDirective);let


FatigueAlertPlotterController=function(){_createClass(FatigueAlertPlotterController,null,[{key:'$inject',get:function()
{
return['$scope'];
}}]);

function FatigueAlertPlotterController($scope){var _this2=this;_classCallCheck(this,FatigueAlertPlotterController);
this._overThresholdPoints=null;

$scope.$watch('controller.plotArea',function(){
if(_.exists(_this2.plotArea)){
_this2.plotArea.registerPlotter(_this2);
}
});
}FatigueAlertPlotterController.prototype.









redraw=function redraw(){var _this3=this;
if(!this._scalesValid){
return;
}

const halfStrokeWidth=this.strokeWidth/2;
const verticalOffset=!_.exists(this.offsetTop)?
halfStrokeWidth:
Math.max(this.offsetTop-halfStrokeWidth,halfStrokeWidth);

if(!_.exists(this._overThresholdPoints)){
const{top:top}=TimeSeries.splitAroundThresholdWithInterpolation(this.points,this.threshold);
this._overThresholdPoints=top;
}

let line=d3.svg.line().
x(function(point){return _this3.horizontalAxis.scale(point.time)}).
y(function(point){return verticalOffset}).
interpolate('linear').
defined(function(point){return!isNaN(point.value)});

let group=
d3.select(this.plotArea.svgElement).
insert('g','.sleep').
attr({
class:`${this.class} alert`,
mask:`url(#${this.mask}-${this.plotArea.id})`});


group.append('rect').attr({

height:'100%',
width:'100%',
fill:'none'});


group.append('path').attr({
fill:'none',
"stroke-width":this.strokeWidth,
d:line(this._overThresholdPoints)});

};_createClass(FatigueAlertPlotterController,[{key:'_scalesValid',get:function(){return _.exists(this.horizontalAxis)&&_.exists(this.horizontalAxis.scale)&&_.exists(this.verticalAxis)&&_.exists(this.verticalAxis.scale)}}]);return FatigueAlertPlotterController}();


module.exports=FatigueAlertPlotterDirective;
//# sourceMappingURL=fatigueAlertPlotterDirective.js.map
